import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../core/auth/auth.service';

@Component({
  selector: 'app-google',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './google.component.html',
  styleUrl: './google.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoogleComponent implements OnInit {
  private code: string = '';

  constructor(private route: ActivatedRoute, private router: Router, private http: HttpClient, private authService: AuthService) {}

  // -----------------------------------------------------------------------------------------------------
  //  @ Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const code = params['code'];
      if (code) {
        this.authService.googleSignIn(code).subscribe({
          next: () => {
            this.router.navigate(['/']);
          },
          error: error => {
            console.error('Google sign-in error:', error);
            this.router.navigate(['/error']);
          },
        });
      } else {
        this.router.navigate(['/error']);
      }
    });
  }
}
